import { toast } from 'react-toastify'
import { SubmissionError } from 'redux-form'

import { SagaIterator } from 'redux-saga'
import { all, call, put, takeLatest, take } from 'redux-saga/effects'
import {
  getApartmentAvailability,
  getApartmentAvailabilitySuccess,
  getApartmentAvailabilityFail,
  getApartmentAvailabilitiesByApplicants,
  getApartmentAvailabilitiesByApplicantsSuccess,
  getApartmentAvailabilitiesByApplicantsFail,
  createApplicantAvailability,
  createApplicantAvailabilitySuccess,
  createApplicantAvailabilityFail,
  deleteApplicantAvailability,
  deleteApplicantAvailabilitySuccess,
  deleteApplicantAvailabilityFail
} from '../actions/applicantAvailability'
import { Action } from '../reducers/types'
import Api from '../services/applicantAvailability'
import i18n from '../translations/i18n'

export function* handleGetApartmentAvailability({
  payload: { apartmentId }
}: Action): SagaIterator {
  try {
    const availability: any = yield call(
      Api.getApartmentAvailabilities,
      apartmentId
    )

    yield put(getApartmentAvailabilitySuccess(availability))
  } catch (error) {
    yield put(getApartmentAvailabilityFail(error.message))
  }
}

export function* handleGetApartmentAvailabilityByApplicants({
  payload: { apartmentId, applicationId }
}: Action): SagaIterator {
  try {
    const availability: any = yield call(
      Api.getApartmentAvailabilitiesByApplicants,
      apartmentId,
      applicationId
    )
    yield put(getApartmentAvailabilitiesByApplicantsSuccess(availability))
  } catch (error) {
    yield put(getApartmentAvailabilitiesByApplicantsFail(error.message))
  }
}

export function* handleCreateAvailability({
  payload: { formData, resolve, reject }
}: Action): SagaIterator {
  try {
    const createdAvailability = yield call(Api.createAvailabilities, formData)
    yield put(createApplicantAvailabilitySuccess(createdAvailability))
    // yield put(reset('SuggestShowingTimesForm'))
    const { apartmentId, applicationId } = formData
    yield put(
      getApartmentAvailabilitiesByApplicants({ apartmentId, applicationId })
    )
    resolve()
  } catch (error) {
    yield put(createApplicantAvailabilityFail(error.message))
    if (error?.errors?._error) {
      yield call(
        reject,
        new SubmissionError({
          _error: i18n.t(`error.availabilities.create`)
          // _error: i18n.t(`error.showings.${error.errors._error}`)
        })
      )
    } else {
      yield call(
        reject,
        new SubmissionError({
          /** TODO get body of backend response for better translation handling */
          _error: i18n.t(`error.availabilities.create`)
        })
      )
    }
  }
}

export function* handleDeleteAvailability({
  payload: { apartmentId, applicationId, applicantAvailabilityId }
}: Action): SagaIterator {
  try {
    yield call(Api.deleteAvailability, applicantAvailabilityId)
    yield put(
      getApartmentAvailabilitiesByApplicants({ apartmentId, applicationId })
    )
    yield take(getApartmentAvailabilitiesByApplicantsSuccess)
    yield put(deleteApplicantAvailabilitySuccess(applicantAvailabilityId))
  } catch (error) {
    yield put(deleteApplicantAvailabilityFail(error.message))
    toast.error(i18n.t('error.availabilities.delete'))
  }
}

function* watchApplicantAvailabilityActions(): SagaIterator {
  yield all([
    takeLatest(getApartmentAvailability, handleGetApartmentAvailability),
    takeLatest(
      getApartmentAvailabilitiesByApplicants,
      handleGetApartmentAvailabilityByApplicants
    ),
    takeLatest(createApplicantAvailability, handleCreateAvailability),
    takeLatest(deleteApplicantAvailability, handleDeleteAvailability)
  ])
}

export default [watchApplicantAvailabilityActions]
